import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography } from '@mui/material';
import {
	Table,
	TableHeader,
	TableBody,
	TableCell,
	TableRow,
	TableContainer,
} from '@windmill/react-ui';
import VendorServices from 'services/VendorServices'; //   updated from AgentsServices

const StatusModal = ({ isOpen, onClose, selectedData }) => {
	const [remarksData, setRemarksData] = useState();

	useEffect(() => {
		if (isOpen && selectedData?.id) {
			fetchVendorRemarks();
		} else {
			setRemarksData(undefined);
		}
		// eslint-disable-next-line
	}, [isOpen]);

	const fetchVendorRemarks = async () => {
		try {
			const res = await VendorServices.getRemarksById(selectedData.id); //   uses Vendor API

			if (res.status) {
				setRemarksData(res.data);
			}
		} catch (err) {
			console.log('Error fetching vendor remarks:', err);
		}
	};

	return (
		<Modal
			open={isOpen}
			onClose={onClose}
			aria-labelledby="modal-title"
			aria-describedby="modal-description"
		>
			<Box
				sx={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					bgcolor: 'background.paper',
					boxShadow: 24,
					padding: '20px',
					maxWidth: 900,
					width: '100%',
					borderRadius: '8px',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						mb: 2,
					}}
				>
					<Typography variant="h6">Vendor Remarks</Typography>
					<button
						onClick={onClose}
						className="text-gray-500 hover:text-gray-800 transition duration-200"
						style={{
							background: 'transparent',
							border: 'none',
							cursor: 'pointer',
							fontSize: '1.2rem',
						}}
						aria-label="Close"
					>
						✕
					</button>
				</Box>

				<Box sx={{ display: 'flex', justifyContent: 'center' }}>
					{remarksData?.length > 0 ? (
						<TableContainer
							style={{
								maxHeight: '65vh',
								overflowY: 'scroll',
								scrollbarWidth: 'thin',
							}}
						>
							<Table>
								<TableHeader>
									<tr>
										<TableCell className="text-center">
											<b>Date</b>
										</TableCell>
										<TableCell className="text-center">
											<b>User</b>
										</TableCell>
										<TableCell className="text-center">
											<b>Status</b>
										</TableCell>
										<TableCell className="text-center">
											<b>Reason</b>
										</TableCell>
									</tr>
								</TableHeader>

								<TableBody style={{ fontSize: '14px' }}>
									{remarksData.map((row) => (
										<TableRow key={row.id}>
											<TableCell className="text-center">
												{row.created_date?.split(' ')[0]}
											</TableCell>
											<TableCell className="text-center">
												{row.action_by_emp || '-'}
											</TableCell>
											<TableCell className="text-center">
												{row.action}
											</TableCell>
											<TableCell
												className="text-center"
												style={{
													maxWidth: '250px',
													wordWrap: 'break-word',
													whiteSpace: 'normal',
												}}
											>
												{row.remark || '-'}
											</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</TableContainer>
					) : (
						<Typography variant="body2" color="textSecondary">
							No remarks available
						</Typography>
					)}
				</Box>
			</Box>
		</Modal>
	);
};

export default React.memo(StatusModal);
